

export class EmployeeVersionDetails {
  employeeNumber: number;
  platform = 'Web';
  version: string;
}
export class EmployeeDetails {
  Platform: string;
   EmployeeNumbers:Employee[]
    }
export class Employee {
  EmpNumber: string;
  Password?: string;
}

